import { createFileRoute, Outlet } from '@tanstack/react-router';
import { BettingWarningBanner } from 'components/betting-warning-banner';
import Navbar from 'components/Navbar/Navbar.component';

export const Route = createFileRoute('/_auth/_layout_with_navbar')({
  component: LayoutWithNavbar,
});

function LayoutWithNavbar() {
  return (
    <>
      <Navbar />
      <BettingWarningBanner />

      <Outlet />
    </>
  );
}
